import React, { useEffect, useState } from "react";
import {
  ConfigProvider,
  Modal,
  Button,
  Form,
  Input,
  Image,
  Alert,
  Row,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAccessToken } from "../../../utils";
import { changePassword } from "../../../api/repositories";
import PasswordHide from "../../../assets/images/svgs/ic_passwordhide_changepassword.svg";
import PasswordShow from "../../../assets/images/svgs/ic_passwordshow_changepassword.svg";
import { setInvalidToken } from "../../../redux/features/main/invalidTokenSlice";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useTranslation } from "react-i18next";
import {
  borderInputChangePassword,
  borderErrorInputChangePassword,
  textInputChangePassword,
  textDescriptionChangePassword,
  textTitleChangePassword,
  colorTextTitleMobile,
  colorTextDesc,
  colorButtonLogOut,
  colorTextList,
} from "../../../config/constant/color/index";

const ChangePassword = ({
  openModalPassword,
  setModalPassword,
  setModalSuccessPassword,
}) => {
  const screens = useBreakpoint();
  const isScallingVersion =
    (window?.innerWidth <= 991 && window.innerWidth >= 768) ||
    window?.innerWidth === 581;
  const isMobileVersion = screens.xs || isScallingVersion;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [hidePassword, setHidePassword] = useState(true);
  const [errInput, setErrInput] = useState(false);
  const [err, setErr] = useState("");

  const resetState = () => {
    setPassword("");
    setConfirmPassword("");
    setHidePassword(true);
    setErr("");
    setErrInput(false);
  };

  useEffect(() => {
    setErr("");
    setErrInput(false);
  }, [password, confirmPassword]);

  useEffect(() => {
    resetState();
  }, [openModalPassword]);

  const handleSubmit = async () => {
    const messageAlert = (
      <>
        {t("feature.home.pop_up_change_password.password_doesnt_match")}
        <br />
        {t("feature.home.pop_up_change_password.please_review")}
      </>
    );
    if (
      password == confirmPassword &&
      password != "" &&
      confirmPassword != ""
    ) {
      const payload = {
        password: password,
        password_confirmation: confirmPassword,
        change_password_type: "temporary",
      };

      try {
        const { status } = await changePassword(
          { data: payload },
          getAccessToken(),
        );
        dispatch(setInvalidToken(status));
        if (status == 200) {
          setPassword("");
          setConfirmPassword("");
          setHidePassword(true);

          setModalSuccessPassword(true);
          setModalPassword(false);
        } else if(status == 400) {
          setErr(message);
          setErrInput(true);
        } else {
          setErr(messageAlert);
          setErrInput(true);
        }
      } catch (err) {
        setErr(err);
      }
    } else {
      setErr(messageAlert);
      setErrInput(true);
    }
  };

  const handlerCancel = () => {
    setModalPassword(!openModalPassword);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            borderRadius: "8px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
      <Modal
        className={
          isMobileVersion
            ? "modal-change-password-mobile"
            : "modal-change-password"
        }
        open={openModalPassword}
        maskClosable="false"
        closeIcon={null}
        transitionName="ant-fade"
        width={432}
        style={{ maxWidth: isMobileVersion ? "90%" : "432px" }}
        centered
        footer={null}
      >
        <div style={{ padding: isMobileVersion ? "20px" : "32px" }}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <p
              style={{
                color: isMobileVersion
                  ? colorTextTitleMobile
                  : textTitleChangePassword,
                fontWeight: "500",
                fontSize: isMobileVersion ? "16px" : "22px",
                marginBottom: isMobileVersion ? "0px" : "10px",
              }}
            >
              {t("feature.home.pop_up_change_password.change_password")}
            </p>
            <p
              style={{
                color: isMobileVersion
                  ? colorTextDesc
                  : textDescriptionChangePassword,
                fontSize: "14px",
                fontWeight: "400",
                margin: 0,
              }}
            >
              {t(
                "feature.home.pop_up_change_password.please_create_new_password",
              )}
            </p>
          </div>

          {err && (
            <Alert
              message={err}
              type="error"
              className="alert-custom text-center"
              style={{
                marginBottom: "20px",
                borderRadius: isMobileVersion ? "6px" : "4px",
              }}
            />
          )}

          <Form onFinish={handleSubmit}>
            <div
              className="d-flex"
              style={{
                position: "relative",
                marginBottom: isMobileVersion ? "16px" : "20px",
              }}
            >
              <Input
                type={hidePassword ? "password" : "false"}
                className="form-control d-flex"
                style={{
                  borderRadius: "8px",
                  color: isMobileVersion
                    ? colorTextTitleMobile
                    : textInputChangePassword,
                  border: "1px solid",
                  borderColor: errInput
                    ? borderErrorInputChangePassword
                    : borderInputChangePassword,
                  height: "40px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
                id="id-new-password-change-password"
                placeholder={t(
                  "feature.home.pop_up_change_password.new_password",
                )}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
              <div
                name="btn-hide-password-login"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: "5%",
                }}
                onClick={() => setHidePassword(!hidePassword)}
              >
                {hidePassword ? (
                  <Image
                    src={PasswordShow}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                ) : (
                  <Image
                    src={PasswordHide}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                )}
              </div>
            </div>
            <div className="d-flex" style={{ position: "relative" }}>
              <Input
                type={hidePassword ? "password" : "false"}
                className="form-control d-flex"
                style={{
                  borderRadius: "8px",
                  color: isMobileVersion
                    ? colorTextTitleMobile
                    : textInputChangePassword,
                  border: "1px solid",
                  borderColor: errInput
                    ? borderErrorInputChangePassword
                    : borderInputChangePassword,
                  height: "40px",
                }}
                id="id-confirm-new-password-change-password"
                placeholder={t(
                  "feature.home.pop_up_change_password.confirm_new_password",
                )}
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
              />
              <div
                name="btn-hide-change-password"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: "5%",
                }}
                onClick={() => setHidePassword(!hidePassword)}
              >
                {hidePassword ? (
                  <Image
                    src={PasswordShow}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                ) : (
                  <Image
                    src={PasswordHide}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                )}
              </div>
            </div>

            {isMobileVersion ? (
              <Row
                style={{
                  justifyContent: "space-between",
                  flexWrap: "nowrap",
                  gap: "4%",
                  marginTop: "24px",
                }}
              >
                <Button
                  key="cancel-change-password"
                  className="btn btn-sm btn-secondary"
                  style={{
                    width: "48%",
                    borderRadius: "6px",
                    border: "1px solid " + colorButtonLogOut,
                    fontWeight: "500",
                    fontSize: "14px",
                    height: "40px",
                  }}
                  name="btn-cancel-change-password"
                  onClick={handlerCancel}
                >
                  {t("feature.home.pop_up_change_password.cancel")}
                </Button>
                <Button
                  key="change-password"
                  className="btn btn-sm btn-primary"
                  style={{
                    width: "48%",
                    borderRadius: "6px",
                    fontWeight: "500",
                    height: "40px",
                    fontSize: "14px",
                  }}
                  name="btn-change-password"
                  htmlType="submit"
                >
                  {t("feature.home.pop_up_change_password.change_password")}
                </Button>
              </Row>
            ) : (
              <div>
                <Button
                  key="change-password"
                  className="btn btn-sm btn-primary btn-block"
                  style={{
                    borderRadius: "6px",
                    border: "none",
                    fontWeight: "500",
                    height: "48px",
                    marginTop: "32px",
                  }}
                  name="btn-change-password"
                  htmlType="submit"
                >
                  {t("feature.home.pop_up_change_password.change_password")}
                </Button>
                <div
                  className="btn-link box-shadow-0"
                  style={{
                    fontWeight: "500",
                    border: "none",
                    marginTop: "20px",
                    textAlign: "center",
                  }}
                  name="btn-cancel-change-password"
                  onClick={handlerCancel}
                >
                  {t("feature.home.pop_up_change_password.cancel")}
                </div>
              </div>
            )}
          </Form>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ChangePassword;
